import React from "react";
import { connect } from "react-redux";

import EntityAnnotation, { EntityAnnotationProps } from "@app/component/EntityAnnotation";
import { useMap } from "@app/component/map/FeaturedMap";
import { hideAnnotation } from "@app/scene/map/store/mapMode/actions";
import { MapModeAnnotationView } from "@app/scene/map/store/mapMode/MapModeState";
import { getAnnotation } from "@app/scene/map/store/mapMode/selectors";
import { RootState } from "@app/store/rootReducer";

import Legend from "../../enums/Legend";
import { getLayerLegendsState } from "../../store/layers/selectors";

interface Props extends Pick<EntityAnnotationProps, "actions" | "showGenericActions"> {
  alertsVisible: boolean;
  annotation?: MapModeAnnotationView;
  onHide: () => void;
}

const MapEntityAnnotation: React.FC<Props> = ({ alertsVisible, annotation, onHide, ...props }) => {
  const { map } = useMap();

  if (!annotation) {
    return null;
  }

  return (
    <EntityAnnotation
      {...props}
      {...annotation}
      forceShowEngagement={alertsVisible}
      map={map}
      onHide={onHide}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  alertsVisible: getLayerLegendsState(state)[Legend.ALERTS].visible,
  annotation: getAnnotation(state),
});

const mapDispatchToProps = {
  onHide: hideAnnotation,
};

export default connect(mapStateToProps, mapDispatchToProps)(MapEntityAnnotation);
